import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function ImpressumPage() {
  return <div className="min-h-screen bg-white" data-id="element-1960">
      <Header data-id="element-1961" />
      <main className="w-full pt-32" data-id="element-1962">
        <div className="max-w-5xl mx-auto py-16 px-6 md:px-12" data-id="element-1963">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-1964">
            Impressum
          </h1>
          <section className="mb-12" data-id="element-1965">
            <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-1966">
              1. Verantwortlich für den Bereich München
            </h2>
            <div className="prose prose-lg max-w-none text-gray-600" data-id="element-1967">
              <p className="font-medium" data-id="element-1968">Dr. Angelika Sturny</p>
              <p data-id="element-1969">Praxis für Beratung und Psychotherapie</p>
              <p data-id="element-1970">Feinerweg 18</p>
              <p data-id="element-1971">85540 Haar (b. München)</p>
              <p data-id="element-1972">Telefon: +49 151 22 89 34 02</p>
              <p data-id="element-1973">
                E-Mail:{' '}
                <a href="mailto:praxis@angelikasturny.com" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1974">
                  praxis@angelikasturny.com
                </a>
              </p>
              <p className="font-medium mt-6" data-id="element-1975">Berufsbezeichnung:</p>
              <p data-id="element-1976">Psychologische Psychotherapeutin (verliehen in Deutschland)</p>
              <p className="font-medium mt-6" data-id="element-1977">Zuständige Kammer:</p>
              <p data-id="element-1978">
                Bayerische Landeskammer der Psychologischen Psychotherapeuten
                und der Kinder- und Jugendlichenpsychotherapeuten (PTK Bayern)
              </p>
              <p data-id="element-1979">Maria-Theresia-Straße 11, 81675 München</p>
              <p data-id="element-1980">
                <a href="https://www.ptk-bayern.de" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1981">
                  www.ptk-bayern.de
                </a>
              </p>
              <p className="font-medium mt-6" data-id="element-1982">
                Gesetzliche Berufsbezeichnungen und berufsrechtliche Regelungen:
              </p>
              <ul className="list-disc pl-5 space-y-1" data-id="element-1983">
                <li data-id="element-1984">Psychotherapeutengesetz (PsychThG)</li>
                <li data-id="element-1985">Heilberufekammergesetz des Landes Bayern</li>
                <li data-id="element-1986">Berufsordnung der PTK Bayern</li>
              </ul>
              <p className="font-medium mt-6" data-id="element-1987">Berufshaftpflichtversicherung:</p>
              <p data-id="element-1988">
                (Name der Versicherung, Anschrift, Geltungsbereich – z. B.
                Deutschland)
              </p>
              <p className="font-medium mt-6" data-id="element-1989">Schwerpunkte:</p>
              <p data-id="element-1990">
                Einzelberatung und Psychotherapie · Systemische Familientherapie
                · Systemische Paartherapie · Beratung und Therapie für Kinder
                und Jugendliche
              </p>
            </div>
          </section>
          <hr className="my-12 border-gray-200" data-id="element-1991" />
          <section className="mb-12" data-id="element-1992">
            <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-1993">
              2. Verantwortlich für den Bereich Frankfurt
            </h2>
            <div className="prose prose-lg max-w-none text-gray-600" data-id="element-1994">
              <p className="font-medium" data-id="element-1995">Eva Sophie Schifferer</p>
              <p data-id="element-1996">Praxis für Psychotherapie und Coaching</p>
              <p data-id="element-1997">Günthersburgallee 82</p>
              <p data-id="element-1998">60389 Frankfurt am Main</p>
              <p data-id="element-1999">Telefon: +49 171 80 80 455</p>
              <p data-id="element-2000">
                E-Mail:{' '}
                <a href="mailto:praxis@evaschifferer.com" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-2001">
                  praxis@evaschifferer.com
                </a>
              </p>
              <p className="font-medium mt-6" data-id="element-2002">Berufsbezeichnung:</p>
              <p data-id="element-2003">Psychologische Psychotherapeutin (verliehen in Deutschland)</p>
              <p className="font-medium mt-6" data-id="element-2004">Zuständige Kammer:</p>
              <p data-id="element-2005">Landespsychotherapeutenkammer Hessen (LPPKJP Hessen)</p>
              <p data-id="element-2006">Böhmerstraße 9, 60322 Frankfurt am Main</p>
              <p data-id="element-2007">
                <a href="https://www.lppkjp.de" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-2008">
                  www.lppkjp.de
                </a>
              </p>
              <p className="font-medium mt-6" data-id="element-2009">
                Gesetzliche Berufsbezeichnungen und berufsrechtliche Regelungen:
              </p>
              <ul className="list-disc pl-5 space-y-1" data-id="element-2010">
                <li data-id="element-2011">Psychotherapeutengesetz (PsychThG)</li>
                <li data-id="element-2012">Heilberufsgesetz des Landes Hessen</li>
                <li data-id="element-2013">Berufsordnung der LPPKJP Hessen</li>
              </ul>
              <p className="font-medium mt-6" data-id="element-2014">Berufshaftpflichtversicherung:</p>
              <p data-id="element-2015">
                (Name der Versicherung, Anschrift, Geltungsbereich – z. B.
                Deutschland)
              </p>
              <p className="font-medium mt-6" data-id="element-2016">Schwerpunkte:</p>
              <p data-id="element-2017">
                Integrative Paarberatung · Coaching · Psychotherapie · Mentale
                Gesundheit
              </p>
            </div>
          </section>
          <hr className="my-12 border-gray-200" data-id="element-2018" />
          <section data-id="element-2019">
            <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-2020">
              Allgemeine Hinweise
            </h2>
            <div className="space-y-8" data-id="element-2021">
              <div data-id="element-2022">
                <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-2023">
                  Haftung für Inhalte
                </h3>
                <div className="prose prose-lg max-w-none text-gray-600" data-id="element-2024">
                  <p data-id="element-2025">
                    Die Inhalte dieser Website wurden mit größter Sorgfalt
                    erstellt. Für die Richtigkeit, Vollständigkeit und
                    Aktualität der Inhalte können jedoch weder Dr. Angelika
                    Sturny noch Eva Sophie Schifferer eine Gewähr übernehmen.
                  </p>
                  <p data-id="element-2026">
                    Als Dienstanbieterinnen sind wir gemäß § 7 Abs. 1 TMG für
                    eigene Inhalte auf diesen Seiten nach den allgemeinen
                    Gesetzen verantwortlich.
                  </p>
                  <p data-id="element-2027">
                    Nach §§ 8 bis 10 TMG sind wir als Dienstanbieterinnen jedoch
                    nicht verpflichtet, übermittelte oder gespeicherte fremde
                    Informationen zu überwachen oder nach Umständen zu forschen,
                    die auf eine rechtswidrige Tätigkeit hinweisen.
                  </p>
                  <p data-id="element-2028">
                    Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
                    Informationen nach den allgemeinen Gesetzen bleiben hiervon
                    unberührt. Eine entsprechende Haftung ist jedoch erst ab dem
                    Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
                    möglich. Bei Bekanntwerden solcher Rechtsverletzungen werden
                    die betroffenen Inhalte umgehend entfernt.
                  </p>
                </div>
              </div>
              <div data-id="element-2029">
                <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-2030">
                  Haftung für Links
                </h3>
                <div className="prose prose-lg max-w-none text-gray-600" data-id="element-2031">
                  <p data-id="element-2032">
                    Diese Website enthält Links zu externen Websites Dritter,
                    auf deren Inhalte wir keinen Einfluss haben. Deshalb können
                    wir für diese fremden Inhalte auch keine Gewähr übernehmen.
                  </p>
                  <p data-id="element-2033">
                    Für die Inhalte der verlinkten Seiten ist stets der
                    jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                  </p>
                  <p data-id="element-2034">
                    Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung
                    auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte
                    waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                  </p>
                  <p data-id="element-2035">
                    Eine permanente inhaltliche Kontrolle der verlinkten Seiten
                    ist jedoch ohne konkrete Anhaltspunkte einer
                    Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
                    Rechtsverletzungen werden derartige Links umgehend entfernt.
                  </p>
                </div>
              </div>
              <div data-id="element-2036">
                <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-2037">
                  Urheberrecht
                </h3>
                <div className="prose prose-lg max-w-none text-gray-600" data-id="element-2038">
                  <p data-id="element-2039">
                    Die durch die Seitenbetreiberinnen erstellten Inhalte und
                    Werke auf dieser Website unterliegen dem deutschen
                    Urheberrecht.
                  </p>
                  <p data-id="element-2040">
                    Beiträge Dritter sind als solche gekennzeichnet. Die
                    Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                    Verwertung außerhalb der Grenzen des Urheberrechts bedürfen
                    der schriftlichen Zustimmung der jeweiligen Autorin bzw.
                    Erstellerin.
                  </p>
                  <p data-id="element-2041">
                    Downloads und Kopien dieser Seite sind nur für den privaten,
                    nicht kommerziellen Gebrauch gestattet.
                  </p>
                  <p data-id="element-2042">
                    Soweit die Inhalte auf dieser Seite nicht von den
                    Betreiberinnen erstellt wurden, werden die Urheberrechte
                    Dritter beachtet. Sollten Sie trotzdem auf eine
                    Urheberrechtsverletzung aufmerksam werden, bitten wir um
                    einen entsprechenden Hinweis. Bei Bekanntwerden von
                    Rechtsverletzungen werden derartige Inhalte umgehend
                    entfernt.
                  </p>
                </div>
              </div>
              <div data-id="element-2043">
                <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-2044">
                  Streitbeilegung / Verbraucherschlichtung
                </h3>
                <div className="prose prose-lg max-w-none text-gray-600" data-id="element-2045">
                  <p data-id="element-2046">
                    Wir sind nicht verpflichtet und auch nicht bereit, an
                    Streitbeilegungsverfahren vor einer
                    Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </div>
              </div>
              <div data-id="element-2047">
                <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-2048">
                  Credits
                </h3>
                <div className="prose prose-lg max-w-none text-gray-600" data-id="element-2049">
                  <p data-id="element-2050">
                    Bildrechte:{' '}
                    <a href="https://www.fotograf-frankfurt.photo/de" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-2051">
                      Martin Leissl
                    </a>
                    ,{' '}
                    <a href="https://www.berndhartung.de/" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-2052">
                      Bernd Hartung
                    </a>
                  </p>
                  <p data-id="element-2053">
                    Logogestaltung:{' '}
                    <a href="https://www.b-99.de/" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-2054">
                      Sven Grot
                    </a>
                  </p>
                  <p data-id="element-2055">
                    Webdesign & Umsetzung:{' '}
                    <a href="https://simonbogner.de/" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-2056">
                      Simon Bogner
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer data-id="element-2057" />
    </div>;
}